import { render } from "./SimpleContainer.vue?vue&type=template&id=06390f78&ts=true&lang=pug"
import script from "./SimpleContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleContainer.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__